import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from '../../services/http.service';
import { AccountUserService } from 'src/app/service/account.service';
import { environment } from 'src/environments/environment';
import { GelAllContactRequestModel } from '../../models/filter.model';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TypeGroupIds } from '../../constants/category-groupid.constants';
import { Contact } from './models/contactInterface.constant';

@Injectable({
  providedIn: 'root',
})
export class SharedContactV1Service {
  // URLs from environment
  private contactURL = environment.contactURL + 'Contact/';
  private coreUrl = environment.coreUrl;
  private localAppUrl = environment.localApiUrl;
  private apiUrlAccount = environment.apiUrlAccount;
  private leadUrl = environment.apiUrlNewLead;
  private accountUrl = environment.apiUrlAccount;


  // Default headers for the HTTP requests
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  user: any;

  constructor(
    private httpService: HttpService, // Unused but assuming you need it later
    private http: HttpClient,
    private accountUserService: AccountUserService
  ) {
    // Subscribe to user data if it's needed for making API requests
    this.accountUserService.user.subscribe((x) => (this.user = x));
  }

  // Method to fetch the contact list with error handling
  getContactList(
    requestModel: GelAllContactRequestModel
  ): Observable<any> {
    const url = `${this.contactURL}GetPagedListWithFilter`;

    // Making a POST request with requestModel and handling errors if any
    return this.http.post(url, requestModel, { headers: this.headers }).pipe(
      catchError((error) => {
        console.error('Error fetching contact list', error);
        throw error; // You can also return a fallback here like `return of([])` if you want to handle errors smoothly.
      })
    );
  }

  getAssociationName(
    requestModel: any
  ): Observable<any> {
    let url;
    url = true? `${this.leadUrl}v2/Lead/GetPagedList` : `${this.leadUrl}v2/Lead/GetPagedList`;
    // if(true){
    //   url = `${this.leadUrl}v2/Lead/GetPagedList`;
    // }
    // else{
    //   url = `${this.leadUrl}v2/Lead/GetPagedList`;
    // }
    // Making a POST request with requestModel and handling errors if any
    return this.http.post(url, requestModel, { headers: this.headers }).pipe(
      catchError((error) => {
        console.error('Error fetching contact list', error);
        throw error; // You can also return a fallback here like `return of([])` if you want to handle errors smoothly.
      })
    );
  }

  getContactCount(filter: string, isActive: boolean,globalChannelId:number){
    return this.httpService.post(`${environment.contactURL}Contact/Count`, {
        filter: filter,
        isActive: isActive,
        globalChannelId: globalChannelId
    });
  } 

  getAllContactTypes() {
    return this.http.get<any>(`${this.coreUrl}Type?groupId=${TypeGroupIds.ContactType}`)
        .toPromise()
        .then(res => res);
  }

  getAllContactAssociation() {
    return this.http.get<any>(environment.contactURL + 'ContactAssociationType/')
  }

  getSalutations() {
    return this.http.get<any>(environment.contactURL + 'Salutation/SalutationMinified')
  }

  getAllGender() {
    return this.http.get<any>(this.coreUrl + 'Gender/GenderMinified')
  }

  getAllLanguage() {
    return this.http.get<any>(this.coreUrl + 'Language/LanguageMinified')
  }

  getAllRoles() {
    return this.http.get<any>(environment.contactURL + 'Type/JobFunctionMinified')
  }

  getAllRelationshipStatus() {
    return this.http.get<any>(this.coreUrl + 'RelationshipStatus/RelationshipStatusMinified')
  }

  getAllMaritalStatus() {
    return this.http.get<any>(this.coreUrl + 'MaritalStatus/MaritalStatusMinified')
  }

  getAllContactSource() {
    return this.http.get<any>(this.coreUrl + 'Source/SourceMinified')
  }

  getAllAnnualIncome() {
    return this.http.get<any>(this.coreUrl + 'AnnualIncome/AnnualIncomeMinified')
  }

  getAllDegree() {
    return this.http.get<any>(this.coreUrl + 'Degree/DegreeMinified')
  }

  getAllStudyField() {
    return this.http.get<any>(this.coreUrl + 'FieldOfStudy/FieldOfStudyMinified')
  }

  addContact(c) {
    return this.http.post<any>(this.contactURL, c)
  }

  getContactById(contactId,associationTypeId) {
    let url =`${this.contactURL}AssociationType/${associationTypeId||0}/Contact/${contactId}`;
    return this.http.get<any>(url).toPromise().then(res => res);;
  }

  
  getContactDetailsById(contactId: number, associationTypeId: number) {
    const url = `${this.contactURL}AssociationType/${associationTypeId || 0}/Contact/${contactId}`;
    return this.http.get<any>(url); 
  }

  updateContact(contact: Contact): Observable<any> {
    return this.http.put<any>(this.contactURL, contact);
  }

  deleteContact(id,associationTypeId) {
    return this.http.delete<any>(`${this.contactURL}AssociationType/${associationTypeId}/Contact/${id}`)
        .toPromise()
        .then(res => res);
  }
  
}
